import { connect } from 'react-redux';
import { setField, addPerson, removePerson, setPersonField } from '@actions/conference';
import { requestTranscriptCompletionEmail } from '@actions/attendees';
import {
  selectConference,
  selectDefaultAttendees,
  selectPeople,
} from '@selectors/conference';
import { selectNumbersByCountries } from '@selectors/countries';
import { isSuperAdmin } from '@selectors/authentication';
import ConferenceCallView from './ConferenceCallView';

const mapStateToProps = (state) => ({
  conferenceData: selectConference(state),
  numbersByCountries: selectNumbersByCountries(state),
  isCurrentUserSuperAdmin: isSuperAdmin(state),
  people: selectPeople(state),
  defaultAttendees: selectDefaultAttendees(state),
});

const mapDispatchToProps = {
  setField,
  addPerson,
  removePerson,
  setPersonField,
  requestTranscriptCompletionEmail,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConferenceCallView);



// WEBPACK FOOTER //
// ./components/templates/ConferenceCallView/index.js